export const ENV = {
  NODE_ENV: process.env.NODE_ENV,
  VITE_APP_API_ENV: process.env.VITE_APP_API_ENV,
  VITE_APP_API_BASE_URL: process.env.VITE_APP_API_BASE_URL,
  VITE_APP_API_BASE_URL_MOCK: process.env.VITE_APP_API_BASE_URL_MOCK,
  VITE_SENSORS_SERVER_URL: process.env.VITE_SENSORS_SERVER_URL,
  VITE_DEFAULT_PROTOCOL_ID: process.env.VITE_DEFAULT_PROTOCOL_ID,
}

export const getEnvironment: () => 'local' | 'pre' | 'prod' = () => {
  if (ENV.NODE_ENV === 'development') {
    return 'local' // local表示本地环境
  } else if (ENV.VITE_APP_API_ENV === 'qa') {
    return 'pre' // pre表示预发环境
  } else {
    return 'prod' // prod表示线上环境
  }
}
